import { render, staticRenderFns } from "./ControlFile.vue?vue&type=template&id=1c2208ea&"
import script from "./ControlFile.vue?vue&type=script&lang=js&"
export * from "./ControlFile.vue?vue&type=script&lang=js&"
import style0 from "./ControlFile.vue?vue&type=style&index=0&id=1c2208ea&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "general/lang/ControlFile.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Freleases%2Ffront%2Ffront_131%2Fsrc%2Fgeneral%2Fcomponents%2Fcontrols%2FControlFile.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports